
import CreationUploader from './creation-uploader.vue';

export default {
  components: {
    CreationUploader: CreationUploader
  },

  props: {
    fileList: {
      type: Array,
      required: true
    },

    setFileList: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      submitButton: {
        loading: false
      },
      limit: 10
    };
  },


  methods: {
    onUploadSuccess: function onUploadSuccess(res, file) {},


    // 选择文件与上传成功后都运行该方法
    onFileChange: function onFileChange(file, fileList) {
      if (fileList.length <= this.limit) {
        this.setFileList(fileList);
      } else {
        this.$message.error('\u6279\u91CF\u4E0A\u4F20\u6587\u4EF6\u4E0D\u80FD\u8D85\u8FC7' + this.limit + '\u4E2A');
        fileList.length = this.limit;
      }
    },
    onFileRemove: function onFileRemove(file, fileList) {
      this.setFileList(fileList);
    },
    submit: function submit() {
      this.$emit('submit');
    }
  }
};